import script from "./MapGames.vue?vue&type=script&setup=true&lang=js"
export * from "./MapGames.vue?vue&type=script&setup=true&lang=js"

import "./MapGames.vue?vue&type=style&index=0&id=4cf36e6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf36e6b"]])

export default __exports__